import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import VinWonderDetail from './VinWonderDetail';
import action from "../../../../../actions";
import * as vinWonderActions from './../../../../../actions/vinWonderAction';
import * as tagActions from './../../../../../actions/tagAction';

const mapStateToProps = state => {
    return {
        file: state.uploadReducer,
        vinWonders: state.vinWonderReducer,
        tagGroupState: state.tagGroupReducer,
        tagGroupDetailState: state.tagGroupDetailReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUploadFile: (filters) => dispatch(action.uploadAction(filters)),
        onCreateVinWonder: (params) => dispatch(vinWonderActions.createVinWonderAction(params)),
        onUpdateVinWonder: (id) => dispatch(vinWonderActions.updateVinWonderAction(id)),
        onGetUpdate: (id) => dispatch(vinWonderActions.getUpdateVinWonderAction(id)),
        createVinWonderTranslate: (vinWonder, language) => dispatch(vinWonderActions.createVinWonderTranslate(vinWonder, language)),
        updateVinWonderTranslate: (vinWonder, language) => dispatch(vinWonderActions.updateVinWonderTranslate(vinWonder, language)),
        deleteVinWonderTranslate: (vinWonder, refreshParams) => dispatch(vinWonderActions.deleteVinWonderTranslate(vinWonder, refreshParams)),
        getVinWonderSites: () => dispatch(vinWonderActions.vinWonderSitesAction()),
        getVinWonderTypes: () => dispatch(vinWonderActions.vinWonderTypesAction()),
        getAllTagGroup: () => dispatch(tagActions.getAllTagGroup()),
        getTagBySku: (id) => dispatch(tagActions.getTagBySku(id)),
        getTagInTagroup: (params) => dispatch(tagActions.getTagInTagroup(params)),
        updateTagGroupSKUMapping: (skuTags) => dispatch(tagActions.updateTagGroupSKUMapping(skuTags)),
        setTagBySku: (skuTags) => dispatch(tagActions.setTagBySku(skuTags)),
        setAllTagGroup: (allTag) => dispatch(tagActions.setAllTagGroup(allTag)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VinWonderDetail));
